import Checkbox from '@mui/material/Checkbox';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Checkbox": Checkbox } } });
export default ClientProvider;
